import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { StickyTabs } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const SerpOverlayModalBody = styled(Flex)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
`;

export const SerpOverlayIframe = styled.iframe`
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
    border: none;
`;

export const SerpOverlayContentWrapper = styled(Flex)`
    position: relative;
    flex-direction: column;
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
`;

export const SerpOverlaySubHeader = styled(Flex)`
    width: 100%;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    ${setElevation("Z1")};
`;

export const SerpOverlayModalContent = styled(Flex)`
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const SerpOverlayTabPanel = styled(Flex)<{ $isActive: boolean }>`
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    display: ${({ $isActive }) => ($isActive ? "flex" : "none")};
`;

export const SerpOverlayTabPanelLoader = styled(Flex)`
    position: absolute;
    inset: 0;
    z-index: 1;
    align-items: center;
    justify-content: center;
    background: ${colorsPalettes.carbon[0]};
`;

export const StyledStickyTabs = styled(StickyTabs)`
    justify-content: flex-start;
    height: 100%;

    & .react-tabs {
        width: 100%;
        height: 100%;
        border-bottom: none;

        ul {
            height: 100%;
            border-bottom: none;
        }
    }
`;
